"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "erula": {
    "bae1fac4": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "basile": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "485f05d0": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "carra-casu": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2194b076": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "ispiene": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a1b3c5e": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "la-inistra": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f5857fe9": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "la-lionaglia": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8beeda7": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "lu-frassu": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a504520e": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "muru-traessu": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "56dbd935": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "pubattu": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e8758619": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuseppe": [{
      "hkey": "0acfc5ae",
      "slug": "erula",
      "name": "Erula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e823c77c": [{
      "hkey": "97153f16",
      "slug": "su-muntiju-e-s-omine",
      "name": "Su Muntiju e S'Omine",
      "primary": true,
      "skipSearch": false
    }],
    "su-montju-e-s-omine": [{
      "hkey": "97153f16",
      "slug": "su-muntiju-e-s-omine",
      "name": "Su Muntiju e S'Omine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;